<template>
  <div id="plan-list">
    <div class="empty" v-if="planList.length == 0">
      <div v-if="!userBaseInfo.is_vip">
        <div class="tip">您尚未定制任何方案</div>
        <button @click="toPurchase">立即定制</button>
      </div>
      <div v-else>
        <div class="tip">方案定制中</div>
      </div>
    </div>
    <ul else>
      <li
        v-for="(item, index) in planList" :key="index" 
        :class="item.status ? 'finished' : 'not-finished'">
        <div class="tag">方案<i>{{index+1}}</i></div>
        <p class="title">{{honorific}}的家庭保障方案</p>
        <p class="intro">{{item.status?'您的方案出来啦 赶快来看详情吧':'方案制作中'}}</p>
        <p class="time">{{item.created_at}}</p>
        <button @click="checkPlan(item)">查看方案</button>
      </li>
    </ul>

    <van-popup v-model="disShow"  position="bottom">
       <div class="discov">
          <p class="desc">评价服务</p>
          <div class="deccimg">
            <p>请对本次服务做出评价</p>
            <div class="agree">
              <div :class="{active:is_satisfied==1}" @click="isSatisfied(1)"><img src="../assets/images/plan/small.png" /><span>十分满意</span></div>
              <div :class="{active:is_satisfied==-1}" @click="isSatisfied(-1)"><img src="../assets/images/plan/cray.png" /><span>很不满意</span></div>
            </div>
          </div>
              <div class="checkfive" v-show="is_satisfied==1" :key="2">
                <span @click="checkSatisfied('plan_option')"><span :class="{active:plan_option==1}">方案保障全面</span></span>
                <span @click="checkSatisfied('plan_premium')"><span :class="{active:plan_premium==1}">产品性价比高</span></span>
                <span @click="checkSatisfied('plan_tutorial')"><span :class="{active:plan_tutorial==1}">讲解细致专业</span></span>
                <span @click="checkSatisfied('attitude')"><span :class="{active:attitude==1}">服务态度好</span></span>
                <span @click="checkSatisfied('speed')"><span :class="{active:speed==1}">回复及时</span></span>
              </div>
              <div class="checkfive"  v-show="is_satisfied==-1" :key="1">
                <span @click="checkSatisfied('plan_option')"><span :class="{active:plan_option==-1}">方案不满意</span></span>
                <span @click="checkSatisfied('plan_premium')"><span :class="{active:plan_premium==-1}">费用超出预算</span></span>
                <span @click="checkSatisfied('plan_tutorial')"><span :class="{active:plan_tutorial==-1}">讲解不清楚</span></span>
                <span @click="checkSatisfied('attitude')"><span :class="{active:attitude==-1}">服务态度差</span></span>
                <span @click="checkSatisfied('speed')"><span :class="{active:speed==-1}">回复不及时</span></span>
              </div>
          <div class="write">
            <textarea placeholder="请写下您的评价" v-model="other"></textarea>
          </div>    
          <p class="dissubmit" @click="submit">提交评论</p>
        </div>
    </van-popup>




  </div>
</template>

<script>
// 方案列表
export default {
  name: 'planList',
  data(){
    return{
      userBaseInfo: {},
      honorific: '',
      planList: [],
      disShow:false,//评价弹框
      is_satisfied:1,//是否满意
      plan_option:0,//方案搭配
      plan_premium:0,//方案价格
      plan_tutorial:0,//方案讲解
      attitude:0,//态度
      speed:0,//速度
      other:'',//其他
    }
  },
  methods:{
    // 提交
    submit(){
      this.axios({
        method:'POST',
        url:'/plan/feed-back',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        },
        data:{
          is_satisfied:this.is_satisfied,
          plan_option:this.plan_option,
          plan_premium:this.plan_premium,
          plan_tutorial:this.plan_tutorial,
          attitude:this.attitude,
          speed:this.speed,
          other:this.other
        }
      }).then((data)=>{
        if(data.data.code == 0){
          this.$toast('评价成功')
          this.disShow = false;
        }
      })
    },
    // 选中的参数
    checkSatisfied(option){
      if(this.is_satisfied == 1){
        if(this[option] == 1){ //重复点击取消
          this[option] = 0
        }else{
          this[option] = 1
        }
      }else if(this.is_satisfied == -1){
        if(this[option] == -1){ //重复点击取消
          this[option] = 0
        }else{
          this[option] = -1
        }
      }
    },
    // 是否满意
    isSatisfied(statisnum){
      this.is_satisfied= statisnum;
      this.plan_option= 0;//方案搭配
      this.plan_premium= 0;//方案价格
      this.plan_tutorial= 0;//方案讲解
      this.attitude= 0;//态度
      this.speed= 0;//速度
    },
    // 获取用户信息
    getUserInfo() {
      this.axios({
        method: 'GET',
        url: '/user',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        }
      }).then((res) => {
        if(res.data.code == 0){
          this.userBaseInfo = res.data.data
          this.Storage.set('userBaseInfo', res.data.data)
        }
      })
    },
    // 获取全部方案
    getPlan(){
      this.axios({
        method: 'GET',
        url: '/plan',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        }
      }).then((res) => {
        if(res.data.code == 0){
          this.honorific = res.data.data.honorific
          this.planList = res.data.data.plans
          if(res.data.data.is_feedback == 1){
            this.disShow = true;
          }
        }
      })
    },
    // 查看方案详情
    checkPlan(item){
      if(item.status){
        this.$router.push({
          path:'/planDetail',
          query: {
            planId: item.id
          }
        })
      }else{
        this.$toast('您的方案还在制作中哦')
      }
    },
    toPurchase(){
      this.$router.push('/')
    }
  },
  created(){
    this.getPlan()
    let s_info = this.Storage.get('userBaseInfo')
    if(s_info){
      this.userBaseInfo = s_info
    }else{
      this.getUserInfo()
    }
    this.Global.getShareConfig({
      title: '点击获取私人家庭保障方案',
      desc: '一对一咨询，分析风险，定制保障方案，让你买的放心，保的全面'
    },this)
  }
}
</script>

<style scoped>
 .checkfive>span>.active{
   color: #FFA127;
   background:rgba(255,246,235,1);
   border-color:rgba(255,161,39,1);
 }
.dissubmit{
  width: 19.19rem;
  height: 3.13rem;
  background:rgba(255,161,39,1);
  text-align: center;
  line-height: 3.13rem;
  font-size: 1.13rem;
  color: white;
  margin: 1.88rem auto;
}
.discov>.write{
  width: 19.13rem;
  margin: 0 auto;
}
.discov>.write>textarea{
  width: 100%;
  height: 4.88rem;
  border:0.05rem solid rgba(214,214,214,1);
  border-radius:0.2rem;
  background:rgba(234,234,234,1);
  resize: none;
  box-sizing: border-box;
  padding: 0.63rem 1.19rem;
}
.checkfive>span>span{
  display: inline-block;
  width: 9rem;
  border-radius:0.5rem;
  border:0.05rem solid rgba(201,201,201,1);
  font-size:1.13rem;
  text-align: center;
  
}
.checkfive>span:nth-child(2n)>span{
  float: right;
}
.checkfive>span{
  width: 50%;
  height: 2.5rem;
  line-height: 2.5rem;
  color:rgba(179,179,179,1);
  margin-bottom: 1.06rem;
}
.checkfive{
  display: flex;
  flex-wrap: wrap;
  width: 19.13rem;
  margin: 0 auto;
  transition: transform 0.3s
}
.agree{
  display: flex;
  margin: 1rem 0;
  justify-content: space-around;
}
.agree>.active{
  color: #FFA127;
}
.agree>.active>img{
  filter: grayscale(0)
}
.agree>div>img{
  width: 2.29rem;
  height: 2.29rem;
  margin-right: 0.56rem;
  filter: grayscale(100%)
}
.agree>div{
  display: flex;
  align-items: center;
}
.deccimg{
  width: 19.13rem;
  margin: 0 auto;
}
.deccimg>p{
  text-align: center;
  font-size: 0.88rem;
  margin: 1.06rem 0 0rem;
  color:rgba(255,161,39,1);
}
.desc{
  text-align: center;
  font-size:1.25rem;
  line-height: 2.17rem;
  border-bottom:0.01rem solid rgba(195,195,195,1);
  padding: 0.5rem 0;
}
.discov{
  width: 100%;
}
i{
  font-weight: 600;
    margin-left: 0.2rem;
}
  #plan-list{
    min-height: 100vh;
    background: #FFFDFC;
  }
  .empty{
    position: relative;
    height: 37rem;
    background: url(../assets/images/common/404.png) no-repeat;
    background-size: 100%;
    background-position: 0 3rem;
    text-align: center;
  }
  .empty .tip{
    font-size: 1.03rem;
    font-weight: 400;
    color: #7C756F;
    padding-top: 25rem;
  }
  .empty button{
    margin-top: 3rem;
    border-radius: 1.48rem;
    width: 21rem;
    height: 2.79rem;
    line-height: 2.79rem;
    box-shadow: 0.0625rem 0.34rem 0.56rem 0 rgba(245, 130, 18, 0.27);
    color: #FFF;
    font-size: 1.25rem;
    font-weight: 500;
  }
  ul li{
    width: 22.4375rem;
    height: 7.9375rem;
    margin: 1.4rem auto;
    overflow: hidden;
    position: relative;
  }
  ul li.finished{
    background: url(../assets/images/plan/finished.png) no-repeat right;
    background-size: auto 100%;
  }
  ul li.not-finished{
    background: url(../assets/images/plan/not-finished.png) no-repeat right;
    background-size: auto 100%;
  }
  ul li .tag{
    width: 5.5625rem;
    height: 1.45rem;
    margin: 0.5rem 0 0;
    position: relative;
    display: flex;
  }
  ul li.finished .tag{
    background: url(../assets/images/plan/tag-f.png) no-repeat;
    background-size: 100%;
  }
  ul li.not-finished .tag{
    background: url(../assets/images/plan/tag-nf.png) no-repeat;
    background-size: 100%;
  }
  ul li .tag::before{
    content: '';
    display: inline-block;
    width: 0.8rem;
    height: 0.8rem;
    margin-left: 0.5625rem;
    margin-right: 0.31rem;
  }
  ul li.finished .tag::before{
    background: url(../assets/images/plan/gou.png) no-repeat;
    background-size: 100%;
  }
  ul li.not-finished .tag::before{
    background: url(../assets/images/plan/cha.png) no-repeat;
    background-size: 100%; 
  }
  ul li .tag{
    font-size: 0.75rem;
    align-items: center;
  }
  ul li.finished .tag{
    /* content: '制定完成'; */
    color: #FF6A10;
  }
  ul li.not-finished .tag{
    /* content: '未制定完'; */
    color: #9E9E9E;
  }
  ul li button{
    position: absolute;
    right: 0.9375rem;
    bottom: 0.75rem;
    background: #FFF;
    border-radius: 0.875rem;
    font-size: 0.875rem;
    font-weight: 600;
    width: 5.1875rem;
    height: 1.8125rem;
    line-height: 1.8125rem;
    text-align: center;
  }
  ul li.finished button{
    color:rgba(255,161,39,1);
  }
  ul li.not-finished button{
    color: #9A9A9A;
  }
  ul li p{
    padding-left: 1.8125rem;
    font-size: 0.69rem;
    color: #FFF;
    vertical-align: text-top;
  }
  ul li .title{
    margin-top: 0.5rem;
    font-size: 1.19rem;
    height: 1.3125rem;
    font-weight:600;
  }
  ul li.finished .title{
    font-size:1.19rem;
    font-family:Alibaba PuHuiTi;
    line-height:1.38rem;
    color:rgba(255,255,255,1);
    text-shadow:0.9270510077476501px 2.8531694412231445px 4px rgba(227,69,0,0.25);
  }
  ul li .intro{
    /* height: 0.75rem; */
    margin: 0.5rem 0 1rem;
  }
  ul li .time{
    height: 0.5625rem;
  }
</style>